const normalizeHttpUrl = (raw) => {
    if (!raw) return null;
    const v = String(raw).trim();
    const withProto = /^https?:\/\//i.test(v) ? v : `https://${v}`;

    try {
        const u = new URL(withProto);
        if (!["http:", "https:"].includes(u.protocol)) return null;
        return u.toString();
    } catch {
        return null;
    }
};

export default normalizeHttpUrl;